import {useNavigate} from "react-router-dom";
import {useSetUserSession} from "../../../state/user-session";
import {useEffect} from "react";
import {queryStringToObject} from "../../../utils/collection-util";
import {callBackLogin} from "../domain/callback-login";

export function CallbackGoogleLogin() {
    const navigate = useNavigate();
    const [login,] = useSetUserSession()

    useEffect(() => {
        const queryParams = queryStringToObject(window.location.href.split('#')[1]);
        const token = queryParams.access_token;

        const params = queryStringToObject(queryParams.state)
        params.oauthProvider = "GOOGLE"
        params.oauthAccessToken = token

        callBackLogin(navigate, login, params)
    }, [])
}